(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/serversidehelper/assets/helpers/handlebars-helpers.js') >= 0) return;  svs.modules.push('/components/app/serversidehelper/assets/helpers/handlebars-helpers.js');

var isServerSide = typeof exports === 'object';

registerHelpers(isServerSide ? require('hbs') : Handlebars);
function registerHelpers(hbs) {
  hbs.registerHelper('isServerSide', function(options) {
    if (isServerSide) {
      return options.fn(this);
    }
    return options.inverse(this);
  });
}


 })(window);